<template>
  <div>
    <action-button :color="stopButtonColor" @click="onStopClick">
      Stop Screening
    </action-button>
    <stop-screening-modal
      :open.sync="openStopModal"
      :allow-exclude-remaining="allowExcludeRemaining"
      @exclude-remaining="onExcludeRemaining"
    />
    <stop-screening-premature-modal
      :open.sync="openPrematureStopModal"
      @exclude-remaining="onExcludeRemaining"
    />
  </div>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import StopScreeningModal from './StopScreeningModal';
import StopScreeningPrematureModal from './StopScreeningPrematureModal';
import { Review, Researcher } from '@/models';
import { ScreeningOutcomeResolution } from '@/enums';
import { mapActions } from 'vuex';

export default {
  name: 'StopScreeningButton',
  components: {
    ActionButton,
    StopScreeningModal,
    StopScreeningPrematureModal,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      required: true,
    },
  },
  data: () => ({
    openStopModal: false,
    openPrematureStopModal: false,
  }),
  computed: {
    allowExcludeRemaining() {
      return this.review.researcherIsAdmin(this.currentResearcher);
    },
    stopButtonColor() {
      if (this.review.shouldStopScreening()) {
        return 'error';
      }
      return null;
    },
  },
  methods: {
    ...mapActions({
      excludeRemaining: 'review/markRemainingScreenedNotRelevant',
    }),
    onStopClick() {
      if (
        !this.review.shouldStopScreening() &&
        this.allowExcludeRemaining
      ) {
        this.openPrematureStopModal = true;
      } else {
        this.openStopModal = true;
      }
    },
    onExcludeRemaining() {
      const reason = this.review.shouldStopScreening()
        ? ScreeningOutcomeResolution.SUGGESTED_STOP
        : ScreeningOutcomeResolution.USER_INITIATED_STOP;
      this.excludeRemaining({ review: this.review, reason });
      this.openStopModal = false;
      this.openPrematureStopModal = false;
    },
  },
};
</script>
